export default "__VITE_ASSET__Ba1j3XF___"